// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: var(--ion-color-primary, #01091a);
}

ion-header ion-toolbar {
  --min-height: var(--boxx-modal-toolbar-min-height, 64px);
  --background: #f8f9fb;
  color: var(--boxx-modal-toolbar-color, var(--ion-text-color));
  --background: #fff;
}
ion-header ion-toolbar ::ng-deep ion-title {
  margin-left: var(--boxx-modal-title-margin-left, 16px) !important;
  padding: var(--boxx-modal-title-padding, 0px);
  font-size: var(--boxx-modal-title-font-size, 17px);
  font-weight: var(--boxx-modal-title-font-weight, 700);
}
ion-header ion-toolbar ion-buttons[slot=end] {
  margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);
}
ion-header ion-toolbar #grabber {
  width: var(--boxx-modal-grabber-width, 36px);
  height: var(--boxx-modal-grabber-height, 5px);
  background: var(--boxx-modal-grabber-background, #c7c7cc);
  margin: var(--boxx-modal-grabber-margin, 0 auto);
  position: var(--boxx-modal-grabber-position, absolute);
  top: var(--boxx-modal-grabber-top, 7px);
  left: var(--boxx-modal-grabber-left, 15px);
  right: var(--boxx-modal-grabber-right, 0);
}
ion-header ion-toolbar ion-searchbar {
  margin: 0px;
  width: 90%;
  margin-left: 5%;
}
ion-header ion-toolbar ion-title {
  color: var(--ion-color-primary);
}
ion-header .mt-toolbar {
  margin-top: 45px;
  border-top-left-radius: var(--boxx-modal-toolbar-topleft-radius, 10px);
  border-top-right-radius: var(--boxx-modal-toolbar-topright-radius, 10px);
  --background: #f8f9fb;
}
ion-header .mt-address {
  margin-top: -1px;
}

ion-content {
  --background: white;
}
ion-content .scroll-list ion-list {
  height: 100%;
}
ion-content ion-radio {
  --color: #ddd;
  --color-checked: var(--ion-color-tertiary);
}
ion-content ion-list {
  border-top-left-radius: 6px;
}
ion-content ion-list ion-item {
  cursor: pointer;
}
ion-content ion-list ion-item ion-icon {
  background: var(--ion-color-primary);
  border-radius: 8px;
  padding: 5px;
  color: #ffffff;
  width: 16px;
  height: 16px;
}
ion-content .delete {
  color: --ion-color-danger !important;
}

@media (min-width: 600px) {
  #pwaPopover {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/custom-location-maps-picker/custom-location-maps-picker.page.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;AACF;;AAEE;EACE,wDAAA;EACA,qBAAA;EACA,6DAAA;EAyBA,kBAAA;AAvBJ;AACI;EACE,iEAAA;EACA,6CAAA;EACA,kDAAA;EACA,qDAAA;AACN;AAEI;EACE,6DAAA;AAAN;AAGI;EACE,4CAAA;EACA,6CAAA;EACA,yDAAA;EACA,gDAAA;EACA,sDAAA;EACA,uCAAA;EACA,0CAAA;EACA,yCAAA;AADN;AAMI;EACE,WAAA;EACA,UAAA;EACA,eAAA;AAJN;AAOI;EACE,+BAAA;AALN;AASE;EACE,gBAAA;EACA,sEAAA;EACA,wEAAA;EACA,qBAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;;AAaA;EACE,mBAAA;AAVF;AAcI;EACE,YAAA;AAZN;AAgBE;EACE,aAAA;EACA,0CAAA;AAdJ;AAiBE;EACE,2BAAA;AAfJ;AAiBI;EACE,eAAA;AAfN;AAiBM;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAfR;AAoBE;EACE,oCAAA;AAlBJ;;AAuBA;EACE;IACE,aAAA;EApBF;AACF","sourcesContent":[":host {\n  background: var(--ion-color-primary, #01091a);\n}\nion-header {\n  ion-toolbar {\n    --min-height: var(--boxx-modal-toolbar-min-height, 64px);\n    --background: #f8f9fb;\n    color: var(--boxx-modal-toolbar-color, var(--ion-text-color));\n\n\n    ::ng-deep ion-title {\n      margin-left: var(--boxx-modal-title-margin-left, 16px) !important;\n      padding: var(--boxx-modal-title-padding, 0px);\n      font-size: var(--boxx-modal-title-font-size, 17px);\n      font-weight: var(--boxx-modal-title-font-weight, 700);\n    }\n\n    ion-buttons[slot=\"end\"] {\n      margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);\n    }\n\n    #grabber {\n      width: var(--boxx-modal-grabber-width, 36px);\n      height: var(--boxx-modal-grabber-height, 5px);\n      background: var(--boxx-modal-grabber-background, #c7c7cc);\n      margin: var(--boxx-modal-grabber-margin, 0 auto);\n      position: var(--boxx-modal-grabber-position, absolute);\n      top: var(--boxx-modal-grabber-top, 7px);\n      left: var(--boxx-modal-grabber-left, 15px);\n      right: var(--boxx-modal-grabber-right, 0);\n    }\n\n    --background: #fff;\n\n    ion-searchbar{\n      margin: 0px;\n      width: 90%;\n      margin-left: 5%;\n    }\n\n    ion-title{\n      color: var(--ion-color-primary);\n    }\n  }\n  \n  .mt-toolbar{\n    margin-top: 45px;\n    border-top-left-radius: var(--boxx-modal-toolbar-topleft-radius, 10px);\n    border-top-right-radius: var(--boxx-modal-toolbar-topright-radius, 10px);\n    --background: #f8f9fb;\n  }\n\n  .mt-address{\n    margin-top: -1px;\n  }\n}\n\n\nion-content {\n  --background: white;\n\n  .scroll-list{\n\n    ion-list{\n      height: 100%;\n    }\n  }\n\n  ion-radio {\n    --color: #ddd;\n    --color-checked: var(--ion-color-tertiary);\n  }\n\n  ion-list {\n    border-top-left-radius: 6px;\n\n    ion-item {\n      cursor: pointer;\n\n      ion-icon {\n        background: var(--ion-color-primary);\n        border-radius: 8px;\n        padding: 5px;\n        color: #ffffff;\n        width: 16px;\n        height: 16px;\n      }\n    }\n  }\n\n  .delete {\n    color: (--ion-color-danger) !important;\n  }\n\n}\n\n@media (min-width: 600px) {\n  #pwaPopover{\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
